import React, { Component } from 'react';
import AdminExtensionTable from './AdminExtensionTable';

export class AdminExtensionContent extends Component {
  render() {

    return (
      <AdminExtensionTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminExtensionContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminExtension/AdminExtensionContent.js